import map from 'lodash/map';
import {
  getEndpoint,
  getHeaders,
  getMPPEndpoint,
} from '../../../helpers/endpoint';

export const REQUEST_FETCH_STATS_NEW_ACTIVE_USERS =
  'REQUEST_FETCH_STATS_NEW_ACTIVE_USERS';
export const SUCCESS_FETCH_STATS_NEW_ACTIVE_USERS =
  'SUCCESS_FETCH_STATS_NEW_ACTIVE_USERS';
export const FAIL_FETCH_STATS_NEW_ACTIVE_USERS =
  'FAIL_FETCH_STATS_NEW_ACTIVE_USERS';

export const fetchStatsNewActiveUsers = (
  payload,
  onSuccess,
  onFail,
  onRequest,
) => {
  return (dispatch, getState) => {
    dispatch({type: REQUEST_FETCH_STATS_NEW_ACTIVE_USERS, payload});
    if (onRequest) onRequest(payload);

    fetch(getEndpoint('fetchStatsNewActiveUsers', payload), {
      method: 'GET',
      headers: getHeaders(getState().authentication),
    })
      .then(response => response.json())
      .then(data => {
        if (data.error) dispatch({type: FAIL_FETCH_STATS_NEW_ACTIVE_USERS});
        else dispatch({type: SUCCESS_FETCH_STATS_NEW_ACTIVE_USERS, data});

        if (onSuccess) onSuccess(data, payload);
      })
      .catch((error, type = FAIL_FETCH_STATS_ACTIVE_USERS) => {
        if (onFail) onFail(type, error);
        dispatch({type, error});
      });
  };
};

export const REQUEST_FETCH_STATS_ACTIVE_USERS =
  'REQUEST_FETCH_STATS_ACTIVE_USERS';
export const SUCCESS_FETCH_STATS_ACTIVE_USERS =
  'SUCCESS_FETCH_STATS_ACTIVE_USERS';
export const FAIL_FETCH_STATS_ACTIVE_USERS = 'FAIL_FETCH_STATS_ACTIVE_USERS';

export const fetchStatsActiveUsers = (
  payload,
  onSuccess,
  onFail,
  onRequest,
) => {
  return (dispatch, getState) => {
    dispatch({type: REQUEST_FETCH_STATS_ACTIVE_USERS, payload});
    if (onRequest) onRequest(payload);

    fetch(getEndpoint('fetchStatsActiveUsers', payload), {
      method: 'GET',
      headers: getHeaders(getState().authentication),
    })
      .then(response => response.json())
      .then(data => {
        if (data.error) dispatch({type: FAIL_FETCH_STATS_ACTIVE_USERS});
        else {
          const users = data.activeUsers;
          const activeUsers = map({...users}, (stat, key) => {
            return {...stat, id: `activeUsers-${key}`, date: key};
          });

          dispatch({
            type: SUCCESS_FETCH_STATS_ACTIVE_USERS,
            data: {...data, activeUsers},
          });
        }

        if (onSuccess) onSuccess(data, payload);
      })
      .catch((error, type = FAIL_FETCH_STATS_ACTIVE_USERS) => {
        if (onFail) onFail(type, error);
        dispatch({type, error});
      });
  };
};

export const REQUEST_FETCH_SEASON_ACTIVE_USERS =
  'REQUEST_FETCH_SEASON_ACTIVE_USERS';
export const SUCCESS_FETCH_SEASON_ACTIVE_USERS =
  'SUCCESS_FETCH_SEASON_ACTIVE_USERS';
export const FAIL_FETCH_SEASON_ACTIVE_USERS = 'FAIL_FETCH_SEASON_ACTIVE_USERS';

export const fetchSeasonActiveUsers = (onSuccess, onFail, onRequest) => {
  return (dispatch, getState) => {
    dispatch({type: REQUEST_FETCH_SEASON_ACTIVE_USERS});
    if (onRequest) onRequest();

    fetch(getEndpoint('fetchSeasonActiveUsers'), {
      method: 'GET',
      headers: getHeaders(getState().authentication),
    })
      .then(response => response.json())
      .then(data => {
        if (data.error) dispatch({type: FAIL_FETCH_SEASON_ACTIVE_USERS});
        else {
          const users = data.activeUsers;
          const activeUsers = map({...users}, (stat, key) => {
            return {...stat, id: `activeUsers-${key}`, date: key};
          });

          dispatch({
            type: SUCCESS_FETCH_SEASON_ACTIVE_USERS,
            data: {...data, activeUsers},
          });
        }

        if (onSuccess) onSuccess(data);
      })
      .catch((error, type = FAIL_FETCH_SEASON_ACTIVE_USERS) => {
        if (onFail) onFail(type, error);
        dispatch({type, error});
      });
  };
};

export const getUsersByChampionship = (
  payload,
  onSuccess,
  onFail,
  onRequest,
) => {
  return (dispatch, getState) => {
    if (onRequest) onRequest();
    fetch(getEndpoint('getUsersByChampionship', payload), {
      method: 'GET',
      headers: getHeaders(getState().authentication),
    })
      .then(response => response.json())
      .then(data => {
        if (data.error) onFail && onFail(data.error);
        else {
          if (onSuccess) onSuccess(data);
        }
      })
      .catch(error => {
        if (onFail) onFail(error);
      });
  };
};

export const REQUEST_FETCH_MPP_STATS_ACTIVE_USERS =
  'REQUEST_FETCH_MPP_STATS_ACTIVE_USERS';
export const SUCCESS_FETCH_MPP_STATS_ACTIVE_USERS =
  'SUCCESS_FETCH_MPP_STATS_ACTIVE_USERS';
export const FAIL_FETCH_MPP_STATS_ACTIVE_USERS =
  'FAIL_FETCH_MPP_STATS_ACTIVE_USERS';

export const fetchMPPStatsActiveUsers = (
  payload,
  onSuccess,
  onFail,
  onRequest,
) => {
  return (dispatch, getState) => {
    dispatch({type: REQUEST_FETCH_MPP_STATS_ACTIVE_USERS, payload});
    if (onRequest) onRequest(payload);

    fetch(getMPPEndpoint('fetchMPPStatsActiveUsers', payload), {
      method: 'GET',
      headers: getHeaders(getState().authentication),
    })
      .then(response => response.json())
      .then(data => {
        if (data.error) dispatch({type: FAIL_FETCH_MPP_STATS_ACTIVE_USERS});
        else {
          const users = data.activeUsers;
          const activeUsers = map({...users}, (stat, key) => {
            return {...stat, id: `activeUsers-${key}`, date: key};
          });

          dispatch({
            type: SUCCESS_FETCH_MPP_STATS_ACTIVE_USERS,
            data: {...data, activeUsers},
          });
        }

        if (onSuccess) onSuccess(data, payload);
      })
      .catch((error, type = FAIL_FETCH_MPP_STATS_ACTIVE_USERS) => {
        if (onFail) onFail(type, error);
        dispatch({type, error});
      });
  };
};



// WEBPACK FOOTER //
// ./src/actions/entities/statistics/activeUsers.js